import { PlaidAccountFacilityMapping } from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

type SyncInput = {
  facilityMappings?: PlaidAccountFacilityMapping[];
};

export const useFinancialAccountSync = createMutationHook(
  'finance.financialAccountSync',
  (input: SyncInput) => ({
    financeFinancialAccountSync: {
      __args: {
        facilityMappings: input.facilityMappings ?? null,
      },
    },
  }),
);
